export default __webpack_public_path__ + "static/media/blue-icon.19072a4e.png";